(function () {
    'use strict';

    angular
        .module('app.users')
        .factory('userEdit.dialog', userEditDialog);

    userEditDialog.$inject = ['$uibModal', '$templateCache', 'opsIncludeVersion'];
    /* @ngInject */
    function userEditDialog($modal, $templateCache, opsIncludeVersion) {
        var service = {
            display: display
        }

        $templateCache.put('userEditDialog.tpl.html?v=' + opsIncludeVersion,
             '<div >' +
             '    <div class="modal-header">' +
             '        <button type="button" class="close" data-dismiss="modal" ' +
             '            aria-hidden="true" data-ng-click="vm.cancel()">&times;</button>' +
             '        <h3>Account Details</h3>' +
             '    </div>' +
             '    <form name="theForm" novalidate>' +
             '    <div class="modal-body" ng-include="\'app/users/_coreDetails.html?v=' + opsIncludeVersion +'\'">' +
             '    </form>' +
             '    </div>' +
             '    <div class="modal-footer">' +
                '        <button class="btn btn-primary" data-ng-click="vm.save()" data-ng-disabled="theForm.$invalid"><i class="fa fa-save"></i>{{vm.okText}}</button>' +
                '        <button class="btn btn-warning" data-ng-click="vm.cancel()"><i class="fa fa-undo"></i>{{vm.cancelText}}</button>' +
                '    </div>' +
             '</div>');

        return service;

        function display() {
            var modalOptions = {
                templateUrl: 'userEditDialog.tpl.html?v=' + opsIncludeVersion,
                controller: UserEditModalInstance,
                controllerAs: "vm",
                keyboard: true,
                size: 'lg',
                resolve: {
                    options: function () {
                        return {
                        };
                    }
                }
            };

            return $modal.open(modalOptions).result;
        }
    }


    UserEditModalInstance.$inject = ['$uibModalInstance', 'options', 'common', 'dataservice', 'userService', 'config'];

    /* @ngInject */
    function UserEditModalInstance($modalInstance, options, common, dataservice, userService, config) {
        /*jshint validthis: true */
        var vm = this;
        vm.okText = 'Update';
        vm.cancelText = 'Cancel';
        vm.item = undefined;
        vm.passwordPattern = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]).{12,}$/;
        vm.showPassword = showPassword;
        vm.requirePassword = requirePassword;
        vm.tenantForUserCrud = {};
        vm.currentPasswordRequired = true;

        vm.save = function () {
            vm.isSaving = true;

            dataservice.saveItem('api/Users/Save', vm.item, true).then(function (saveResult) {
                vm.isSaving = false;
                var result = saveResult.data;
                if (result.Succeeded) {
                    $modalInstance.close('ok');
                }
                else {
                    var errors = "";
                    for (var i = 0; i < result.Errors.length; i++) {
                        errors += result.Errors[i] + "\n";
                    }
                    common.logger.error(errors, "", "Error");
                }
            }, function (error) { })
        };
        vm.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        activate();

        function activate() {
            var promises = [getItem(), getTenantForUserCrud()];
            return common.$q.all(promises).then(function () {
            }, function (error) { });
        }

        function getTenantForUserCrud() {
            dataservice.getItems("api/Tenants/GetForUserCrud").then(function (data) {
                vm.tenantForUserCrud = data.data;
            }, function (error) { })
        }

        function showPassword() {
            if (vm.tenantForUserCrud) {
                if (vm.tenantForUserCrud.ForceSso) {
                    vm.currentPasswordRequired = false;
                    return false;
                }

                return !hasSsoLogin();

            }
            return true;
        }

        function hasSsoLogin() {
            if (vm.item) {
                for (var i = 0; i < vm.item.Logins.length; i++) {
                    if (vm.item.Logins[i].ProviderKey) {
                        return true;
                    }
                }
            }
            return false;
        }

        function requirePassword() {
            return false;
        }


        function getItem() {
            return dataservice.getItem("api/Users/Current")
                .then(function (data) {
                    if (data) {

                        vm.item = data.data;
                    } else {
                        common.logger.warning('Could not find your user');
                    }
                })
                .catch(function (error) {
                    common.logger.error('Error locating your user' + error);
                });
        }
    }
})();
